import { INSTALLER_MENU, PATHS } from '../utils/constants';
import { getSysParams, saveSysParam, getDataDictionarys, saveDictionary, downloadLogFile } from '../services/account';
import { Modal } from 'antd';
import moment from 'moment';

export default {
  namespace: 'sysParam',
  state: {
    iworkData: [],
    meetingData: []
  },
  reducers: {
    update(state, { payload }) {
      return { ...state, ...payload };
    }
  },
  effects: {
    *loadSysParam(_, { put, call, select }) {
      const { locale } = yield select(state => state.i18n);
      const iworkResult = yield call(getSysParams, { locale });
      if (iworkResult.status === 0) {
        yield put({ type: 'update', payload: { iworkData: iworkResult.data } });
      } else {
        Modal.error({ content: iworkResult.msg });
      }
      const meetingResult = yield call(getDataDictionarys, { locale });
      if (meetingResult.status === 0) {
        yield put({ type: 'update', payload: { meetingData: meetingResult.data } });
      } else {
        Modal.error({ content: meetingResult.msg });
      }
    },
    *saveParam({payload}, { put, call, select }) {
      const { locale } = yield select(state => state.i18n);
      const { status, msg } = yield call(saveSysParam, { payload, locale });
      if (status === 1) {
        Modal.error({ content: msg });
      }
    },
    *saveDictionary({payload}, { put, call, select }){
      const { locale } = yield select(state => state.i18n);
      const { status, msg } = yield call(saveDictionary, { payload, locale });
      if (status === 1) {
        Modal.error({ content: msg });
      }
    },
    *downloadLog({payload}, { put, call, select }){
      const { locale } = yield select(state => state.i18n);
      payload.startDate = moment(payload.startDate).format("YYYY-MM-DD");
      payload.endDate = moment(payload.endDate).format("YYYY-MM-DD");
      yield call(downloadLogFile, { payload, locale });
    }
  },
  subscriptions: {
    set({ dispatch, history }) {
      return history.listen(({ pathname }) => {
        if (pathname === PATHS.sysParam) {
          const token = sessionStorage.getItem('token');
          const userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
          if (token && userInfo && userInfo.roleId === 0) {
            dispatch({ type: 'loadSysParam' });
            dispatch({
              type: 'menu/setMenus',
              menus: { data: INSTALLER_MENU, status: 0 }
            });
          } else {
            dispatch({ type: 'top/logOff' });
          }
        } else if(pathname === PATHS.sysLog){
          const token = sessionStorage.getItem('token');
          const userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
          if (token && userInfo && userInfo.roleId === 0) {
            dispatch({
              type: 'menu/setMenus',
              menus: { data: INSTALLER_MENU, status: 0 }
            });
          } else {
            dispatch({ type: 'top/logOff' });
          }
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/models/sysParam.js